import { render } from "./SiteHeader.vue?vue&type=template&id=2e3d5451"
const script = {}

import "./SiteHeader.vue?vue&type=style&index=0&id=2e3d5451&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__